import _includesInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/includes';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _sliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/slice';
import _regeneratorRuntime from '@babel/runtime-corejs3/regenerator';
import _asyncToGenerator from '@babel/runtime-corejs3/helpers/asyncToGenerator';
import axios from 'axios';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _JSON$stringify from '@babel/runtime-corejs3/core-js-stable/json/stringify';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _typeof from '@babel/runtime-corejs3/helpers/typeof';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _Object$entries from '@babel/runtime-corejs3/core-js-stable/object/entries';
import { Vue } from '@sentry/integrations';
import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';
import axiosRetry, { isNetworkError } from 'axios-retry';
import { validate } from 'vee-validate';
import _toConsumableArray from '@babel/runtime-corejs3/helpers/toConsumableArray';
import _reverseInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/reverse';
import { parseISO, parse, format } from 'date-fns';
import _Array$isArray from '@babel/runtime-corejs3/core-js-stable/array/is-array';
import _reduceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/reduce';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import { nb, fi, da, sv } from 'date-fns/locale';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import { kebabCase } from 'lodash-es';
import _findInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/find';

var onProduction = function onProduction() {
  return /(defa.com|^www.salto.no|^master--[\w-]+\.netlify\.app)$/.test(window.location.hostname);
};
var onTest = function onTest() {
  return (// servebolt.com is used for defa.com test environment
    /^(develop--[\w-]+\.netlify\.app|test\.salto\.no|defade-\d+\.bolt\d+\.servebolt\.com)$/.test(window.location.hostname)
  );
};
var onLocal = function onLocal() {
  return /^(localhost|192\.168\.)/.test(window.location.hostname);
};
var onLocalOrTest = function onLocalOrTest() {
  return onTest() || onLocal();
};
var environment = function environment() {
  if (onProduction()) {
    return "production";
  }

  if (onTest()) {
    return "test";
  }

  if (onLocal()) {
    return "local";
  }

  return "local";
};

var _process$env$VUE_APP_;

var RELEASE_VERSION = process.env.RELEASE_VERSION;
var IS_SENTRY_ENABLED_LOCALLY = ((_process$env$VUE_APP_ = process.env.VUE_APP_SENTRY_LOCAL_ENABLE) === null || _process$env$VUE_APP_ === void 0 ? void 0 : _process$env$VUE_APP_.toLowerCase()) === "true";
var API_ORIGIN = process.env.VUE_APP_API_ORIGIN;
var BRING_API_KEY = process.env.VUE_APP_BRING_API_KEY;
var BRING_USER_ID = process.env.VUE_APP_BRING_USER_ID;
var I18N_BASE_URL = process.env.VUE_APP_I18N_BASE_URL;
var I18N_SHEET_NAME = process.env.VUE_APP_I18N_SHEET_NAME;
var I18N_FALLBACK_LOCALE = process.env.VUE_APP_FALLBACK_LOCALE || "nb";

var protectedLocalStorageKeys = ["user-preferences"];

var extractLocalStorageKeyWithVersion = function extractLocalStorageKeyWithVersion(key) {
  var _key$match;

  var keyWithoutLang = (_key$match = key.match(/[\w-]+[\d.]+/)) === null || _key$match === void 0 ? void 0 : _key$match[0];
  return keyWithoutLang || key;
};

var clearLocalStorageIfOnNewVersion = function clearLocalStorageIfOnNewVersion(vuexKey) {
  var localStorageKeyWithVersion = extractLocalStorageKeyWithVersion(vuexKey);

  for (var i = 0; i < window.localStorage.length; i++) {
    var localStorageKey = window.localStorage.key(i); // Never remove protected keys

    if (_includesInstanceProperty(protectedLocalStorageKeys).call(protectedLocalStorageKeys, localStorageKey)) {
      continue;
    } // Don't remove local storage keys with same version but possibly different lang


    if (extractLocalStorageKeyWithVersion(localStorageKey) !== localStorageKeyWithVersion) {
      window.localStorage.removeItem(localStorageKey);
    }
  }
};
var getVuexLocalStorageKey = function getVuexLocalStorageKey(key) {
  var versioned = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getLocale();
  var localStorageKey = key;

  if (versioned) {
    var _context;

    localStorageKey = _concatInstanceProperty(_context = "".concat(localStorageKey, "-")).call(_context, RELEASE_VERSION);
  }

  if (!onProduction()) {
    var _context2;

    localStorageKey = _concatInstanceProperty(_context2 = "".concat(localStorageKey, "-")).call(_context2, locale);
  }

  return localStorageKey;
};

var defaRetailerGroupHandle = "admin";
var publicRetailerGroupHandle = "charger";

function ownKeys$4(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys$4(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys$4(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getUserPreferences = function getUserPreferences() {
  var userPreferences = window.localStorage.getItem("user-preferences");

  if (userPreferences) {
    return JSON.parse(userPreferences);
  }

  return {};
};

var getUserPreferenceValue = function getUserPreferenceValue(userPreferenceKey) {
  var _getUserPreferences;

  return (_getUserPreferences = getUserPreferences()) === null || _getUserPreferences === void 0 ? void 0 : _getUserPreferences[userPreferenceKey];
};
var setUserPreferenceValue = function setUserPreferenceValue(userPreferenceKey, userPreferenceValue) {
  var userPreferences = _objectSpread$4(_objectSpread$4({}, getUserPreferences()), {}, _defineProperty({}, userPreferenceKey, userPreferenceValue));

  window.localStorage.setItem("user-preferences", _JSON$stringify(userPreferences));
}; // ** Retailer Group **

var getRetailerGroupInLocalStorage = function getRetailerGroupInLocalStorage() {
  return getUserPreferenceValue("retailerGroup");
};
var setRetailerGroupInLocalStorage = function setRetailerGroupInLocalStorage(retailerGroup) {
  return setUserPreferenceValue("retailerGroup", retailerGroup);
};

var setDefaultRetailerGroupInLocalStorage = function setDefaultRetailerGroupInLocalStorage() {
  return setRetailerGroupInLocalStorage(defaRetailerGroupHandle);
};

var getAutomaticallySwitchActiveRetailer = function getAutomaticallySwitchActiveRetailer() {
  return getUserPreferenceValue("automaticallySwitchActiveRetailer");
};
var setAutomaticallySwitchActiveRetailer = function setAutomaticallySwitchActiveRetailer() {
  return setUserPreferenceValue("automaticallySwitchActiveRetailer", true);
}; // ** Language Switching  **
// No setter for this as this should be done manually via dev console

var isLanguageSwitcherEnabled = function isLanguageSwitcherEnabled() {
  if (onLocalOrTest()) {
    return getUserPreferenceValue("languageSwitcherEnabled");
  }

  return false;
};
var getLangInLocalStorage = function getLangInLocalStorage() {
  return getUserPreferenceValue("lang");
};
var setLangInLocalStorage = function setLangInLocalStorage(locale) {
  setUserPreferenceValue("lang", locale);
  setDefaultRetailerGroupInLocalStorage();
};

var supportedLocales = function supportedLocales() {
  return ["nb", "sv", "da", "fi"];
}; // See https://github.com/microsoft/TypeScript/issues/26255 on why casting to SupportedLocale is necessary

var isSupportedLocale = function isSupportedLocale(locale) {
  var _context;

  return _includesInstanceProperty(_context = supportedLocales()).call(_context, locale);
};
var mapCountryToLanguage = function mapCountryToLanguage(country) {
  switch (country) {
    case "no":
      return "nb";

    case "se":
      return "sv";

    case "fi":
      return "fi";

    case "dk":
      return "da";

    default:
      return "nb";
  }
};
var extractCountryFromHostname = function extractCountryFromHostname() {
  var countryCodeMatch = window.location.hostname.match(/^[A-Za-z]{2}(?=\.)/);
  return countryCodeMatch ? countryCodeMatch[0] : "no";
};

var extractLanguageFromHostname = function extractLanguageFromHostname() {
  var countryCode = extractCountryFromHostname();
  return mapCountryToLanguage(countryCode);
};

var getLocale = function getLocale() {
  if (!onProduction()) {
    var langInLocalStorage = getLangInLocalStorage();

    if (langInLocalStorage && isSupportedLocale(langInLocalStorage)) {
      return langInLocalStorage;
    }

    var languageSetting = window.navigator.language;

    if (languageSetting) {
      if (_includesInstanceProperty(languageSetting).call(languageSetting, "sv")) {
        return "sv";
      }

      if (_includesInstanceProperty(languageSetting).call(languageSetting, "fi")) {
        return "fi";
      }

      if (_includesInstanceProperty(languageSetting).call(languageSetting, "da")) {
        return "da";
      }
    }
  }

  return extractLanguageFromHostname();
};
var setLangOnHtmlElement = function setLangOnHtmlElement() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getLocale();
  document.documentElement.lang = locale;
};
var getCountry = function getCountry() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getLocale();

  switch (locale) {
    case "nb":
      return "no";

    case "sv":
      return "se";

    case "da":
      return "dk";

    case "fi":
      return "fi";

    default:
      return "no";
  }
};
var inNorway = function inNorway() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getLocale();
  return getCountry(locale) === "no";
};
var inSweden = function inSweden() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getLocale();
  return getCountry(locale) === "se";
};
var inDenmark = function inDenmark() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getLocale();
  return getCountry(locale) === "dk";
};
var inFinland = function inFinland() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getLocale();
  return getCountry(locale) === "fi";
};

var getCurrencyForLocale = function getCurrencyForLocale() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getLocale();

  switch (locale) {
    case "nb":
      return "NOK";

    case "sv":
      return "SEK";

    case "da":
      return "DKK";

    case "fi":
      return "EUR";

    default:
      throw new Error("No currency is configured for a country outside of Norway, Sweden, Finland or Denmark");
  }
};

var portToApp = function portToApp(port) {
  switch (port) {
    case 8080:
      return "EP";

    case 8081:
      return "HC";

    case 8082:
      return "IPV";

    case 8083:
      return "FC";

    default:
      throw new Error("Application with port ".concat(port, " not found. Are you calling this from a non-local environment?"));
  }
};

var fromUrlToApplication = function fromUrlToApplication() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname;

  if (onLocal()) {
    var _url$match, _context;

    // Remove ":". Can't use positive lookbehind for this as Safari does not support this at the time of writing
    var port = ((_url$match = url.match(/:\d{4}/)) === null || _url$match === void 0 ? void 0 : _sliceInstanceProperty(_context = _url$match[0]).call(_context, 1)) || window.location.port;

    if (port) {
      return portToApp(+port);
    }

    return "";
  }

  if (/installation/.test(url)) {
    return "IPV";
  }

  if (/homecheck/.test(url)) {
    return "HC";
  }

  if (/evportal/.test(url)) {
    return "EP";
  }

  if (/facility-configuration|bolt\d+\.servebolt\.com|www\.defa\.com/.test(url)) {
    return "FC";
  }

  return "";
};
var fromUrlToApplicationDisplayName = function fromUrlToApplicationDisplayName(url) {
  var app = fromUrlToApplication(url);

  switch (app) {
    case "EP":
      return "EV Portal";

    case "HC":
      return "Homecheck";

    case "IPV":
      return "Installation Partner View";

    case "FC":
      return "Facility Configuration";

    default:
      return null;
  }
};

var serviceEmail = function serviceEmail(locale) {
  var appIsFC = fromUrlToApplication() === "FC";

  switch (locale) {
    case "nb":
      return appIsFC ? "evsupport.no@defa.com" : "services@defa.com";

    case "sv":
      return appIsFC ? "evsupport.se@defa.com" : "services.se@defa.com";

    case "da":
      return appIsFC ? "evsupport.no@defa.com" : "support@biludstyr.dk";

    case "fi":
      return "tekninentuki@defa.com";

    default:
      throw new Error("No service email was configured for locale ".concat(getLocale()));
  }
};

var serviceEmailAlternative = function serviceEmailAlternative() {
  var hasServiceEmailAlternative = fromUrlToApplication() === "FC" ? false : inSweden();
  return hasServiceEmailAlternative ? "ladd@ahlsell.se" : null;
};

var servicePhone = function servicePhone(locale) {
  var appIsFC = fromUrlToApplication() === "FC";

  switch (locale) {
    case "nb":
      return appIsFC ? "+47 225 08 403" : "+47 320 67 700";

    case "sv":
      return appIsFC ? "+46 104 983 800" : "+46 104 983 800";

    case "da":
      return appIsFC ? "+47 225 08 403" : "+45 867 85 200";

    case "fi":
      return "+3580201527200";

    default:
      throw new Error("No phone number was configured for locale ".concat(getLocale()));
  }
};

var serviceDetails = function serviceDetails() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getLocale();
  var email = serviceEmail(locale);
  var phone = servicePhone(locale);
  var emailAlternative = serviceEmailAlternative();
  return {
    email: email,
    emailLink: "mailto:".concat(email),
    phone: phone,
    phoneLink: "tel:".concat(phone),
    hasEmailAlternative: Boolean(emailAlternative),
    emailAlternative: emailAlternative,
    emailAlternativeLink: emailAlternative ? "mailto:".concat(emailAlternative) : null
  };
};

var setMainAndBackupTranslations = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(i18nInstance) {
    var langMain,
        _yield$axios$get,
        messagesPerLang,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            langMain = _args.length > 1 && _args[1] !== undefined ? _args[1] : getLocale();
            _context.next = 3;
            return axios.get(I18N_BASE_URL, {
              params: {
                langMain: langMain,
                langBackup: I18N_FALLBACK_LOCALE,
                sheetName: I18N_SHEET_NAME
              }
            });

          case 3:
            _yield$axios$get = _context.sent;
            messagesPerLang = _yield$axios$get.data;
            i18nInstance.setLocaleMessage(langMain, messagesPerLang.langMain);

            if (messagesPerLang.langBackup) {
              i18nInstance.setLocaleMessage(I18N_FALLBACK_LOCALE, messagesPerLang.langBackup);
            }

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function setMainAndBackupTranslations(_x) {
    return _ref.apply(this, arguments);
  };
}();

var apiOriginWithCountry = function apiOriginWithCountry() {
  var _context;

  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getLocale();

  switch (locale) {
    case "sv":
      return "".concat(API_ORIGIN, "/sv");

    default:
      return _concatInstanceProperty(_context = "".concat(API_ORIGIN, "/")).call(_context, getCountry(locale));
  }
};
var mediaBaseUrl = function mediaBaseUrl() {
  return "".concat(API_ORIGIN, "/media");
};
var imagesBaseUrl = function imagesBaseUrl() {
  return "".concat(mediaBaseUrl(), "/images");
};
var documentBaseUrl = function documentBaseUrl() {
  return "".concat(mediaBaseUrl(), "/documents");
};
var retailerGroupLogosUrl = function retailerGroupLogosUrl() {
  var _context2;

  var rgLogoColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "w";
  return _concatInstanceProperty(_context2 = "".concat(imagesBaseUrl(), "/evportal-rg-logos-")).call(_context2, rgLogoColor);
};
var pdfBaseUrl = function pdfBaseUrl() {
  return "".concat(apiOriginWithCountry(), "/pdf");
};
var retailerGroupLogoSrc = function retailerGroupLogoSrc(retailerGroupHandle) {
  var _context3;

  var rgLogoColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "w";
  return _concatInstanceProperty(_context3 = "".concat(retailerGroupLogosUrl(rgLogoColor), "/")).call(_context3, retailerGroupHandle, ".png");
};

var getApiBaseUrl = function getApiBaseUrl(locale) {
  return "".concat(apiOriginWithCountry(locale), "/api");
};
var API_VERSION_FEBRUARY_2021 = "2021-02-01";
var API_VERSION_JULY_2021 = "2021-07-01";

function ownKeys$3(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys$3(Object(source), true)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys$3(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var isAxiosError = function isAxiosError(error) {
  return "isAxiosError" in error;
};

var isSentryEnabled = function isSentryEnabled() {
  return onLocal() ? IS_SENTRY_ENABLED_LOCALLY : true;
};

var applicationToClientKey = function applicationToClientKey() {
  if (onLocal()) {
    return "https://b4200cd3d8cf4ca7b379f2870418b204@o433583.ingest.sentry.io/5389068"; // Project "local"
  }

  var currentApplication = fromUrlToApplication();

  switch (currentApplication) {
    case "EP":
      return "https://3f139f22951942feb5b81c3b312082b6@o433583.ingest.sentry.io/5389016";

    case "HC":
      return "https://77469034436d4ff1a5f6818db5f41fdb@o433583.ingest.sentry.io/5389065";

    case "IPV":
      return "https://9bcba0c41da044ac903cc33c13fe503c@o433583.ingest.sentry.io/5389061";

    case "FC":
      return "https://9a563173126b4ebcab1036264dd015c2@o433583.ingest.sentry.io/5699179";

    default:
      throw new Error("No client key has been configured for application ".concat(currentApplication));
  }
};

var configureSentry = function configureSentry(vue, release) {
  var ignoreErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (isSentryEnabled()) {
    Sentry.init({
      dsn: applicationToClientKey(),
      environment: environment(),
      debug: onLocal(),
      ignoreErrors: ignoreErrors,
      release: release,
      integrations: [new Vue({
        Vue: vue,
        attachProps: true,
        logErrors: true
      }), new Integrations.BrowserTracing({
        tracingOrigins: [getApiBaseUrl(), "https://api.bring.com"]
      })],
      tracesSampleRate: 0.2
    });
  }
};
var setUserForSentry = function setUserForSentry(user) {
  return Sentry.setUser({
    id: user.id,
    email: user.email
  });
};

var jsonErrorReportable = function jsonErrorReportable(backendError) {
  var error = {
    message: backendError.message,
    code: backendError.code
  };

  if (backendError.details) {
    var _context;

    _forEachInstanceProperty(_context = _Object$entries(backendError.details)).call(_context, function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          detailKey = _ref2[0],
          detailValue = _ref2[1];

      error["details-".concat(detailKey)] = detailValue.join(" | ");
    });
  }

  return error;
};

var captureExceptionWithSentry = function captureExceptionWithSentry(error, orderId) {
  var tags = {
    "axios.error": isAxiosError(error) ? "yes" : "no"
  };

  if (orderId) {
    tags = _objectSpread$3(_objectSpread$3({}, tags), {}, {
      "order.id": orderId
    });
  }

  if (isAxiosError(error)) {
    var contexts = {
      request: {
        config: error.config
      }
    };

    if (error.response) {
      contexts = _objectSpread$3(_objectSpread$3({}, contexts), {}, {
        response: _objectSpread$3({}, _typeof(error.response.data) === "object" ? {
          jsonError: jsonErrorReportable(error.response.data.error)
        } : {
          htmlErrorMessage: extractMessageFromHTMLErrorResponse(error.response.data)
        })
      });
    }

    Sentry.captureException(error, {
      contexts: contexts,
      tags: tags
    });
  } else {
    Sentry.captureException(error, {
      tags: tags
    });
  }
};

var extractMessageFromHTMLErrorResponse = function extractMessageFromHTMLErrorResponse(html) {
  if (typeof html !== "string") {
    return "Tried to extract HTML from non string response, type of response is ".concat(_typeof(html));
  }

  var selectorMessage = "#message p";
  var dummyEl = document.createElement("html");
  dummyEl.innerHTML = html;
  var errorMessage = dummyEl.querySelector(selectorMessage);

  if (errorMessage) {
    return errorMessage.textContent;
  }

  return "Could mot find message in HTML with selector ".concat(selectorMessage);
};

function ownKeys$2(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys$2(Object(source), true)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys$2(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }
var responseInterceptorExtractData = function responseInterceptorExtractData(response) {
  return response.data;
};
var requestInterceptorAddContextLegacy = function requestInterceptorAddContextLegacy(config) {
  var _config$method, _context;

  var method = (_config$method = config.method) === null || _config$method === void 0 ? void 0 : _config$method.toLowerCase();
  return _objectSpread$2(_objectSpread$2(_objectSpread$2({}, config), method === "get" ? {
    params: _objectSpread$2(_objectSpread$2({}, config.params), {}, {
      "context-app": fromUrlToApplication()
    })
  } : null), method && _includesInstanceProperty(_context = ["post", "put", "patch"]).call(_context, method) ? {
    data: _objectSpread$2(_objectSpread$2({}, config.data), {}, {
      context: {
        app: fromUrlToApplication()
      }
    })
  } : null);
}; // This interceptor should be applied after any interceptors that add the authorization header

var requestInterceptorAddCustomHeaders = function requestInterceptorAddCustomHeaders(config) {
  var _config$headers;

  var headerDefaEPBearer = null;
  var headerDefaEPSecret = null;
  var headerDefaLinkToken = null;
  var authorizationHeader = (_config$headers = config.headers) === null || _config$headers === void 0 ? void 0 : _config$headers.authorization;

  if (authorizationHeader) {
    var hasBearerToken = _includesInstanceProperty(authorizationHeader).call(authorizationHeader, "Bearer");

    if (hasBearerToken) {
      var hasDefaLinkToken = hasBearerToken && /[\w-]+\.[\w-]+\.[\w-]+/.test(authorizationHeader);

      if (hasDefaLinkToken) {
        headerDefaLinkToken = {
          "X-Defa-Link-Token": authorizationHeader
        };
      } else {
        headerDefaEPBearer = {
          "X-Defa-EP-Bearer": authorizationHeader
        };
      }
    } else if (_includesInstanceProperty(authorizationHeader).call(authorizationHeader, "Secret")) {
      headerDefaEPSecret = {
        "X-Defa-EP-Secret": authorizationHeader
      };
    }
  }

  return _objectSpread$2(_objectSpread$2({}, config), {}, {
    headers: _objectSpread$2(_objectSpread$2(_objectSpread$2(_objectSpread$2({}, config.headers), {}, {
      "X-Defa-Context": fromUrlToApplication()
    }, headerDefaEPBearer), headerDefaEPSecret), headerDefaLinkToken)
  });
};

function ownKeys$1(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; _forEachInstanceProperty(_context3 = ownKeys$1(Object(source), true)).call(_context3, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context4; _forEachInstanceProperty(_context4 = ownKeys$1(Object(source))).call(_context4, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Request interceptor order is reversed https://github.com/axios/axios/issues/1663
// This functions exists to hide this confusing behaviour until a fix is implemented in Axios
var applyRequestInterceptorsInOrder = function applyRequestInterceptorsInOrder(_ref) {
  var _context, _context2;

  var axiosInstance = _ref.axiosInstance,
      interceptors = _ref.interceptors;

  _forEachInstanceProperty(_context = _reverseInstanceProperty(_context2 = _toConsumableArray(interceptors)).call(_context2)).call(_context, function (interceptor) {
    return (// eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore https://github.com/axios/axios/issues/3733
      axiosInstance.interceptors.request.use(interceptor, null, {
        // Only accepting synchronous interceptors for now, though it is possible to make this dynamic should we need to
        synchronous: true
      })
    );
  });
};
var setAuthorizationHeaderOnConfig = function setAuthorizationHeaderOnConfig(config, userToken) {
  var _config$headers;

  if ((_config$headers = config.headers) === null || _config$headers === void 0 ? void 0 : _config$headers.authorization) {
    return config;
  }

  return _objectSpread$1(_objectSpread$1({}, config), {}, {
    headers: _objectSpread$1(_objectSpread$1({}, config.headers), userToken ? {
      authorization: "Bearer ".concat(userToken)
    } : null)
  });
};

var getCommentsForOrder = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(axiosInstance, orderId, secret) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", axiosInstance.get("/orders/".concat(orderId, "/comments"), {
              headers: secret ? {
                authorization: "Secret ".concat(secret)
              } : undefined,
              validateStatus: function validateStatus(status) {
                return status === 200;
              },
              transformResponse: [function (data) {
                var comments = JSON.parse(data);

                for (var i = 0; i < comments.length; i++) {
                  comments[i].timestamp = parseISO(comments[i].timestamp);
                  comments[i].timestampRead = comments[i].timestampRead ? parseISO(comments[i].timestampRead) : null;
                }

                return comments;
              }]
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getCommentsForOrder(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var addComment = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(axiosInstance, orderId, comment, secret) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", axiosInstance.post("/orders/".concat(orderId, "/comments"), comment, {
              headers: secret ? {
                authorization: "Secret ".concat(secret)
              } : undefined,
              validateStatus: function validateStatus(status) {
                return status === 200;
              },
              transformResponse: [function (data) {
                var comment = JSON.parse(data);
                comment.timestamp = parseISO(comment.timestamp);
                comment.timestampRead = comment.timestampRead ? parseISO(comment.timestampRead) : null;
                return comment;
              }]
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function addComment(_x4, _x5, _x6, _x7) {
    return _ref2.apply(this, arguments);
  };
}(); // TODO: Change param 'comment' to 'commentId' once backend supports comms

var markCommentAsRead = function markCommentAsRead(axiosInstance, orderId, comment, secret) {
  var _context3;

  return axiosInstance.post(_concatInstanceProperty(_context3 = "/orders/".concat(orderId, "/comments/")).call(_context3, comment.id, "/mark-as-read"), null, {
    headers: secret ? {
      authorization: "Secret ".concat(secret)
    } : undefined,
    validateStatus: function validateStatus(status) {
      return status === 200;
    },
    transformResponse: [function (data) {
      var comment = JSON.parse(data);
      comment.timestamp = parseISO(comment.timestamp);
      comment.timestampRead = comment.timestampRead ? parseISO(comment.timestampRead) : null;
      return comment;
    }]
  });
};

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context4; _forEachInstanceProperty(_context4 = ownKeys(Object(source), true)).call(_context4, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context5; _forEachInstanceProperty(_context5 = ownKeys(Object(source))).call(_context5, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }
var confirmRegistrationOrPasswordRecovery = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(axiosInstance, confirmationUrl, _ref) {
    var approvalUrl, denialUrl;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            approvalUrl = _ref.approvalUrl, denialUrl = _ref.denialUrl;
            _context.next = 3;
            return axiosInstance.post(confirmationUrl, _objectSpread({
              context: {
                app: fromUrlToApplication()
              }
            }, approvalUrl && denialUrl ? {
              approvalUrl: approvalUrl,
              denialUrl: denialUrl
            } : null), {
              headers: {
                version: API_VERSION_JULY_2021,
                "X-Defa-Version": API_VERSION_JULY_2021
              }
            });

          case 3:
            return _context.abrupt("return", _context.sent);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function confirmRegistrationOrPasswordRecovery(_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
var resendConfirmationEmail = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(axiosInstance, _ref3) {
    var _context2;

    var email, confirmationPath;
    return _regeneratorRuntime.wrap(function _callee2$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            email = _ref3.email, confirmationPath = _ref3.confirmationPath;
            _context3.next = 3;
            return axiosInstance.post("/users/resend-confirm", {
              email: email,
              context: {
                app: fromUrlToApplication()
              },
              confirmationUrl: _concatInstanceProperty(_context2 = "".concat(window.location.origin)).call(_context2, confirmationPath)
            }, {
              headers: {
                version: API_VERSION_JULY_2021,
                "X-Defa-Version": API_VERSION_JULY_2021
              }
            });

          case 3:
            return _context3.abrupt("return", _context3.sent);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee2);
  }));

  return function resendConfirmationEmail(_x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();

var withDefaultAxiosTransformers = function withDefaultAxiosTransformers(axiosTransformers) {
  var _context;

  return _concatInstanceProperty(_context = axios.defaults.transformResponse).call(_context, axiosTransformers);
};

var isTimeout = function isTimeout(error) {
  return error.code === "ECONNABORTED";
};
var defaultTimeout = 60000;

var isRegistrationRequest = function isRegistrationRequest(config) {
  var _config$method;

  return config.url === "/users" && ((_config$method = config.method) === null || _config$method === void 0 ? void 0 : _config$method.toLowerCase()) === "post";
};

var withAxiosRetry = function withAxiosRetry(axiosInstance) {
  var retries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
  return axiosRetry(axiosInstance, {
    retries: retries,
    retryCondition: function retryCondition(error) {
      return isTimeout(error) || isNetworkError(error);
    },
    // Taken from https://github.com/softonic/axios-retry/issues/87
    retryDelay: function retryDelay() {
      var retryNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var seconds = Math.pow(2, retryNumber) * 1000;
      var randomMs = 1000 * Math.random();
      return seconds + randomMs;
    }
  });
};
var userFriendlyErrorMessage = function userFriendlyErrorMessage(error) {
  var _error$response;

  if (isTimeout(error)) {
    return "defaNotificationError.message.timeout";
  }

  if (isNetworkError(error)) {
    return "defaNotificationError.message.network";
  }

  var statusCode = (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status;

  if (statusCode && statusCode >= 400 && statusCode < 500) {
    return "defaNotificationError.message.clientError";
  }

  return "defaNotificationError.message.serverError";
};

var isNonExistingPostalCodeError = function isNonExistingPostalCodeError(error) {
  var _error$response2;

  var errorMessages = (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data.error;
  return (errorMessages === null || errorMessages === void 0 ? void 0 : errorMessages.length) === 1 && errorMessages[0].error === "NON_EXISTING_POSTAL_CODE";
};

var getPlaceForPostalCode = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(postalCode) {
    var locale,
        postalCodeRule,
        _yield$validate,
        valid,
        postalCodeWithoutSpaces,
        _context,
        _yield$axios$get,
        data,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            locale = _args.length > 1 && _args[1] !== undefined ? _args[1] : getLocale();
            postalCodeRule = _args.length > 2 && _args[2] !== undefined ? _args[2] : "postalCode";

            if (!postalCode) {
              _context2.next = 21;
              break;
            }

            _context2.next = 5;
            return validate(postalCode, postalCodeRule, {
              name: "i18n-ignore"
            });

          case 5:
            _yield$validate = _context2.sent;
            valid = _yield$validate.valid;

            if (!valid) {
              _context2.next = 21;
              break;
            }

            postalCodeWithoutSpaces = postalCode.replace(/\s/g, "");
            _context2.prev = 9;
            _context2.next = 12;
            return axios.get(_concatInstanceProperty(_context = "https://api.bring.com/pickuppoint/api/postalCode/".concat(getCountry(locale), "/getCityAndType/")).call(_context, postalCodeWithoutSpaces, ".json"), {
              headers: {
                "X-MyBring-API-Uid": BRING_USER_ID,
                "X-MyBring-API-Key": BRING_API_KEY,
                "X-Bring-Client-URL": window.location.origin
              }
            });

          case 12:
            _yield$axios$get = _context2.sent;
            data = _yield$axios$get.data;
            return _context2.abrupt("return", data.postalCode.city);

          case 17:
            _context2.prev = 17;
            _context2.t0 = _context2["catch"](9);

            if (isNonExistingPostalCodeError(_context2.t0)) {
              _context2.next = 21;
              break;
            }

            throw _context2.t0;

          case 21:
            return _context2.abrupt("return", "");

          case 22:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee, null, [[9, 17]]);
  }));

  return function getPlaceForPostalCode(_x) {
    return _ref.apply(this, arguments);
  };
}();
var isAuthenticationError = function isAuthenticationError(error) {
  var _error$response3;

  return ((_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.status) === 401;
};
var isAuthorizationError = function isAuthorizationError(error) {
  var _error$response4;

  return ((_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : _error$response4.status) === 403;
};
var isNotFoundError = function isNotFoundError(error) {
  var _error$response5;

  return ((_error$response5 = error.response) === null || _error$response5 === void 0 ? void 0 : _error$response5.status) === 404;
};
var isRegistrationUsernameAlreadyTakenError = function isRegistrationUsernameAlreadyTakenError(error) {
  var _error$response6, _error$response6$data;

  return isRegistrationRequest(error.config) && // No 400s should be thrown from backend apart from a username already being taken
  ((_error$response6 = error.response) === null || _error$response6 === void 0 ? void 0 : (_error$response6$data = _error$response6.data.error) === null || _error$response6$data === void 0 ? void 0 : _error$response6$data.code) === 400;
};
var shouldErrorBeReported = function shouldErrorBeReported(error) {
  return !(axios.isCancel(error) || isAuthenticationError(error) || isAuthorizationError(error) || isNotFoundError(error) || isRegistrationUsernameAlreadyTakenError(error));
};

var numberStrToDigitArray = function numberStrToDigitArray(value) {
  var _context;

  return _mapInstanceProperty(_context = value.split("")).call(_context, function (digitAsStr) {
    return +digitAsStr;
  });
}; // See  https://en.wikipedia.org/wiki/Luhn_algorithm

var validWithLuhnAlgorithm = function validWithLuhnAlgorithm(digits) {
  var _context2;

  var checksumGiven = digits[digits.length - 1];

  var sumOfDigits = _reduceInstanceProperty(_context2 = _sliceInstanceProperty(digits).call(digits, 0, -1)).call(_context2, function (sum, digit, index) {
    if (index % 2 === 0) {
      var product = digit * 2;

      if (product > 9) {
        var _context3;

        product = _reduceInstanceProperty(_context3 = numberStrToDigitArray("" + product)).call(_context3, function (sum, digit) {
          return sum + +digit;
        }, 0);
      }

      return sum + product;
    }

    return sum + digit;
  }, 0);

  var checksumCalculated = sumOfDigits * 9 % 10;
  return checksumGiven === checksumCalculated;
};
var calculateChecksum = function calculateChecksum(digits, weights) {
  var _context4, _context5;

  var product = _reduceInstanceProperty(_context4 = _mapInstanceProperty(_context5 = _sliceInstanceProperty(digits).call(digits, 0, -1)).call(_context5, function (digit, i) {
    return digit * weights[i];
  })).call(_context4, function (sum, digit) {
    return sum + digit;
  }, 0);

  var productModulus = product % 11;

  if (productModulus === 0) {
    return 0;
  }

  if (productModulus === 1) {
    return -1;
  }

  return 11 - productModulus;
};

var getOrganizationNumberRuleForNorway = function getOrganizationNumberRuleForNorway() {
  var weights = [3, 2, 7, 6, 5, 4, 3, 2];
  return function (value) {
    if (value) {
      var sanitizedValue = value.replace(/\s/g, "");

      if (/^[8-9]\d{8}$/.test(sanitizedValue)) {
        var digits = numberStrToDigitArray(sanitizedValue);
        var checksumCalculated = calculateChecksum(digits, weights);
        var checksumGiven = digits[digits.length - 1];
        return checksumGiven === checksumCalculated;
      }
    }

    return false;
  };
};
/**
 * https://sv.wikipedia.org/wiki/Organisationsnummer#Organisationsnummer &
 * https://en.wikipedia.org/wiki/Personal_identity_number_(Sweden)#Checksum &
 * https://gist.github.com/leon/3238f1aa0ae2bbb6a2b5
 */

var getOrganizationNumberOrPersonalIdentificationNumberRuleForSweden = function getOrganizationNumberOrPersonalIdentificationNumberRuleForSweden(validationType) {
  return function (value) {
    if (value) {
      var sanitizedValue = value.replace(/-/g, "");

      if (/^\d{10,12}$/.test(sanitizedValue)) {
        // Length should be either 10 or 12
        if (sanitizedValue.length === 11) {
          return false;
        }

        var digits = numberStrToDigitArray(sanitizedValue);

        var digitsToCheck = _sliceInstanceProperty(digits).call(digits, -10);

        var sumOfSecondAndThirdDigits = digitsToCheck[2] * 10 + digitsToCheck[3]; // sum should be 20 or greater, otherwise it could be a personal number

        if (validationType === "company" && sumOfSecondAndThirdDigits >= 20) {
          return validWithLuhnAlgorithm(digitsToCheck);
        } // sum should be 12 or lower, as it indicates the person's birth month


        if (validationType === "personal" && sumOfSecondAndThirdDigits <= 12) {
          return validWithLuhnAlgorithm(digitsToCheck);
        }

        return false;
      }
    }

    return false;
  };
}; // https://github.com/vkomulai/finnish-business-ids/blob/master/src/finnish-business-ids.ts

var getOrganizationNumberRuleForFinland = function getOrganizationNumberRuleForFinland() {
  var weights = [7, 9, 10, 5, 8, 4, 2];
  return function (value) {
    if (value) {
      var sanitizedValue = value.replace(/-/g, "");

      if (/^\d{8}$/.test(sanitizedValue)) {
        var digits = numberStrToDigitArray(sanitizedValue);
        var checksumCalculated = calculateChecksum(digits, weights);
        var checksumGiven = digits[digits.length - 1];
        return checksumGiven === checksumCalculated;
      }
    }

    return false;
  };
}; // https://gist.github.com/henrik/daf364fb7e22b3b10cad

var getOrganizationNumberRuleForDenmark = function getOrganizationNumberRuleForDenmark() {
  var weights = [2, 7, 6, 5, 4, 3, 2];
  return function (value) {
    if (value) {
      var sanitizedValue = value.replace(/\s/g, "");

      if (/^\d{8}$/.test(sanitizedValue)) {
        var digits = numberStrToDigitArray(sanitizedValue);
        var checksumCalculated = calculateChecksum(digits, weights);
        var checksumGiven = digits[digits.length - 1];
        return checksumGiven === checksumCalculated;
      }
    }

    return false;
  };
};

var getPostalCodeRule = function getPostalCodeRule() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getLocale();
  return function (value) {
    if (locale === "sv" || locale === "fi") {
      return /^\d{3}\s?\d{2}$/.test(value);
    }

    return /^\d{4}$/.test(value);
  };
};
var getFullNameRule = function getFullNameRule() {
  return function (value) {
    return /^([a-zA-Z0-9æøåöä].+\s+[a-zA-Z0-9æøåöä].*)+$/i.test(value);
  };
};
var getTelephoneRule = function getTelephoneRule() {
  return function (value) {
    var trimmedValue = value.replace(/\s/g, "");
    return /^\+?\d{7,15}$/.test(trimmedValue);
  };
};
var getPasswordRule = function getPasswordRule() {
  return function (value) {
    return /^(?=.*[a-zåøæäö])(?=.*[A-ZÅØÆÄÖ])(?=.*\d)[a-zA-ZåøæäöÅØÆÄÖ\d\w\W]{10,}$/.test(value);
  };
};
var getPersonalIdentificationNumberRule = function getPersonalIdentificationNumberRule() {
  return getOrganizationNumberOrPersonalIdentificationNumberRuleForSweden("personal");
};
var getOrganizationNumberRule = function getOrganizationNumberRule() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getLocale();

  switch (locale) {
    case "nb":
      return getOrganizationNumberRuleForNorway();

    case "sv":
      return getOrganizationNumberOrPersonalIdentificationNumberRuleForSweden("company");

    case "da":
      return getOrganizationNumberRuleForDenmark();

    case "fi":
      return getOrganizationNumberRuleForFinland();

    default:
      throw new Error("Org number validation not implemented for locale ".concat(locale));
  }
}; // Slight variation on required rule where we do allow null.
// This was originally implemented for "circuitBreakerRatedCurrent" field in @defa-as/facility-configuration where a field is required, but null should be valid
// See also https://vee-validate.logaretm.com/v3/guide/required-fields.html

var getRequiredAllowNullRule = function getRequiredAllowNullRule() {
  return {
    validate: function validate(value) {
      var valid = true;

      if (_Array$isArray(value) && value.length !== 0) {
        valid = false;
      }

      if (value === undefined || value === "") {
        valid = false;
      }

      return {
        required: true,
        valid: valid
      };
    },
    computesRequired: true
  };
};

var validationConfigForFields = {
  homecheck: {
    propertyId: "required",
    personalIdentificationNumber: "required|personalIdentificationNumber",
    cableLengthEstimate: "required",
    distributionBoardSpaceAvailable: "required",
    excavationNecessary: "required",
    internetConnection: "required",
    mainFuseCapacity: "required",
    propertyOwnerApproval: "required",
    propertyType: "required",
    solarPanelsOrElectricHeating: "required",
    solarPanels: "required",
    specializedDrillingNecessary: "required",
    voltage: "required"
  }
};

var defaultMessageConfigurationFn = function defaultMessageConfigurationFn(i18nInstance) {
  return function (field, values) {
    // Special field name for ignoring message lookup
    if (field === "i18n-ignore") {
      return "";
    }

    var fieldKey = "veeValidate.fields.".concat(field);
    values._field_ = i18nInstance.te(fieldKey) ? i18nInstance.t(fieldKey) : i18nInstance.t("shared.".concat(fieldKey));
    var localizedRuleKey = "veeValidate.rules.".concat(values._rule_);

    if (i18nInstance.te(localizedRuleKey)) {
      return i18nInstance.t(localizedRuleKey, values);
    }

    var sharedRuleKey = "shared.".concat(localizedRuleKey);

    if (i18nInstance.te(sharedRuleKey)) {
      return i18nInstance.t(sharedRuleKey, values);
    }

    return i18nInstance.t("shared.veeValidate.rules.default", values);
  };
};

var localeToDateFnLocale = function localeToDateFnLocale(locale) {
  switch (locale) {
    case "nb":
      return nb;

    case "sv":
      return sv;

    case "da":
      return da;

    case "fi":
      return fi;

    default:
      return nb;
  }
};

var localizedFormat = function localizedFormat(date, formatStr, locale) {
  return format(date, formatStr, {
    locale: localeToDateFnLocale(locale)
  });
};

var localizedParse = function localizedParse(date, formatStr, locale) {
  return parse(date, formatStr, new Date(), {
    locale: localeToDateFnLocale(locale)
  });
};

var fromIso = function fromIso(value) {
  return typeof value === "string" ? parseISO(value) : value;
};

var formatDateWithFormat = function formatDateWithFormat(value, formatStr) {
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getLocale();
  return value || value === 0 ? localizedFormat(fromIso(value), formatStr, locale) : value;
};

var parseDateShortWithDots = function parseDateShortWithDots(value) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getLocale();
  return localizedParse(value, "dd.MM.yy", locale);
};
var formatDate = function formatDate(value) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getLocale();
  return formatDateWithFormat(value, "d. MMM yyy", locale);
};
var formatDateShort = function formatDateShort(value) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getLocale();
  return formatDateWithFormat(value, "d. MMM", locale);
};
var formatDateShortWithDots = function formatDateShortWithDots(value) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getLocale();
  return formatDateWithFormat(value, "dd.MM.yy", locale);
};
var formatDatetime = function formatDatetime(value) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getLocale();
  return formatDateWithFormat(value, "dd-MM-y-HH:mm", locale);
};
var formatDatetimeLong = function formatDatetimeLong(value) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getLocale();
  return formatDateWithFormat(value, "dd. MMM yyy HH:mm", locale);
};
var formatDatetimeShort = function formatDatetimeShort(value) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getLocale();
  return formatDateWithFormat(value, "d. MMM HH:mm", locale);
};
var formatDatetimeShortWithSeconds = function formatDatetimeShortWithSeconds(value) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getLocale();
  return formatDateWithFormat(value, "d. MMM HH:mm:ss", locale);
};

var isElliOrder = function isElliOrder(retailerName) {
  return retailerName === "Elli";
};

var yesNo = function yesNo() {
  return ["yes", "no"];
};

var homecheckOptions = {
  propertyType: function propertyType() {
    var sharedOptions = ["independentProperty", "cooperativePropertyUnit", "jointPropertyUnit"];

    if (inNorway()) {
      var _context;

      return _concatInstanceProperty(_context = []).call(_context, sharedOptions, ["holidayHome", "semiDetachedHouse"]);
    }

    return sharedOptions;
  },
  propertyOwnerApproval: function propertyOwnerApproval() {
    return ["approved", "approvalNeeded", "approvalNotApplicable"];
  },
  mainFuseCapacity: function mainFuseCapacity() {
    if (inSweden()) {
      return ["16A", "20A", "25A", "other"];
    }

    if (inDenmark()) {
      return ["16A", "25A", "35A"];
    }

    if (inFinland()) {
      return ["25A", "35A", "50A", "63A"];
    }

    return ["32A", "40A", "50A", "63A", "80Ato100A", "other", "unknown"];
  },
  voltage: function voltage() {
    return ["230v", "400v", "unknown"];
  },
  cableLengthEstimate: function cableLengthEstimate() {
    var _context4;

    var sharedOptions = ["unknown"];

    if (inSweden()) {
      var _context2;

      return _concatInstanceProperty(_context2 = [">7", "<7"]).call(_context2, sharedOptions);
    }

    if (inDenmark() || inFinland()) {
      var _context3;

      return _concatInstanceProperty(_context3 = [">15", "<15"]).call(_context3, sharedOptions);
    }

    return _concatInstanceProperty(_context4 = [">10", "<10"]).call(_context4, sharedOptions);
  },
  internetConnection: function internetConnection(charger) {
    var _context5;

    return _concatInstanceProperty(_context5 = []).call(_context5, _toConsumableArray(!charger || charger.supportsEthernet ? ["cable"] : []), _toConsumableArray(!charger || charger.supportsWifi ? ["wifi"] : []), _toConsumableArray(!inNorway() && (!charger || charger.supportsMobile) ? ["mobile"] : []), ["none"]);
  },
  yesNo: yesNo,
  yesNoUnknown: function yesNoUnknown() {
    var _context6;

    return _concatInstanceProperty(_context6 = []).call(_context6, _toConsumableArray(yesNo()), ["unknown"]);
  }
};

var orderStatuses = ["orderReceived", "houseApprovalNeeded", "remoteHomeCheckSent", "remoteHomeCheckCompleted", "installationPartnerChosen", "forwardedToInstaller", "installationPartnerRejected", "installationPartnerConfirmed", "physicalHomeCheckNeeded", "partsNeeded", "hardwareConsignmentSent", "hardwareConsignmentCompleted", "installationAgreed", "completed", "done", "revoked", "deleted"];
var getOrderStatuses = function getOrderStatuses() {
  if (inNorway()) {
    return orderStatuses;
  }

  return _filterInstanceProperty(orderStatuses).call(orderStatuses, function (orderStatus) {
    return orderStatus !== "installationPartnerRejected";
  });
};

var extractDomainFromEmail = function extractDomainFromEmail(email) {
  return email.split("@")[1];
};
var extractDomainFromEmailIncludingAtSymbol = function extractDomainFromEmailIncludingAtSymbol(email) {
  var _email$match;

  return (_email$match = email.match(/@[\w-.]+$/)) === null || _email$match === void 0 ? void 0 : _email$match[0];
};

var OrderClient = /*#__PURE__*/function () {
  function OrderClient(token, params) {
    _classCallCheck(this, OrderClient);

    this.token = token;
    this.params = params;
  }

  _createClass(OrderClient, [{
    key: "fetchOrdersForPage",
    value: function () {
      var _fetchOrdersForPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(page) {
        var _yield$axios$get, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return axios.get("".concat(getApiBaseUrl(), "/orders"), {
                  params: this.paramsWithPageAndLimit(page),
                  headers: {
                    authorization: this.bearerToken,
                    version: API_VERSION_FEBRUARY_2021,
                    "X-Defa-Version": API_VERSION_FEBRUARY_2021
                  }
                });

              case 2:
                _yield$axios$get = _context.sent;
                data = _yield$axios$get.data;
                return _context.abrupt("return", data);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchOrdersForPage(_x) {
        return _fetchOrdersForPage.apply(this, arguments);
      }

      return fetchOrdersForPage;
    }()
  }, {
    key: "fetchOrdersPaged",
    value: function () {
      var _fetchOrdersPaged = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var orders, _yield$this$fetchOrde, ordersForPage, meta, page, _yield$this$fetchOrde2, _ordersForPage;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                orders = [];
                _context2.next = 3;
                return this.fetchOrdersForPage(1);

              case 3:
                _yield$this$fetchOrde = _context2.sent;
                ordersForPage = _yield$this$fetchOrde.data;
                meta = _yield$this$fetchOrde.meta;
                orders.push.apply(orders, _toConsumableArray(ordersForPage));
                page = 2;

              case 8:
                if (!(page <= meta.pagination.total_pages)) {
                  _context2.next = 17;
                  break;
                }

                _context2.next = 11;
                return this.fetchOrdersForPage(page);

              case 11:
                _yield$this$fetchOrde2 = _context2.sent;
                _ordersForPage = _yield$this$fetchOrde2.data;
                orders.push.apply(orders, _toConsumableArray(_ordersForPage));

              case 14:
                page++;
                _context2.next = 8;
                break;

              case 17:
                return _context2.abrupt("return", orders);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchOrdersPaged() {
        return _fetchOrdersPaged.apply(this, arguments);
      }

      return fetchOrdersPaged;
    }()
  }, {
    key: "bearerToken",
    get: function get() {
      return "Bearer ".concat(this.token);
    }
  }, {
    key: "paramsWithPageAndLimit",
    get: function get() {
      var _this = this;

      return function (page) {
        _this.params.set("limit", "250");

        _this.params.set("page", page.toString());

        return _this.params;
      };
    }
  }]);

  return OrderClient;
}();

var colorDefa = "#cc0000";
var theme = {
  colorPrimary: colorDefa,
  colorPrimaryContrastLow: "#fff3f3",
  colorBackground: "white",
  colorGrayContrastLow: "#fcfcfc",
  colorGrayShade1: "#c7c9c7",
  colorGrayShade2: "#b2b4b2",
  colorGrayShade3: "#9ea2a2",
  colorGrayShade4: "#898d8d",
  colorGrayShade5: "#707372",
  colorBlack: "#25282a",
  colorAccent: "#3c8a2e",
  colorTextTint1: "#000",
  colorTextTint2: "#1a1a1a",
  colorTextTint3: "#666",
  colorTextHeadingPrimary: colorDefa,
  // No error color specified in Branding guidelines, so this is chosen as a random, more bright, red than DEFA's red
  colorError: "#ff2c00",
  // Used in cross-application components such as DefaComments
  colorIPV: colorDefa,
  colorEP: "#00B27C"
};
var cssVarPrefix = "--defa-oreon";
var setupThemingOnRootElement = function setupThemingOnRootElement(themeOverride) {
  var _context;

  _forEachInstanceProperty(_context = _Object$entries(theme)).call(_context, function (_ref) {
    var _context2;

    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    window.document.documentElement.style.setProperty(_concatInstanceProperty(_context2 = "".concat(cssVarPrefix, "-")).call(_context2, kebabCase(key)), (themeOverride === null || themeOverride === void 0 ? void 0 : themeOverride[key]) ? themeOverride[key] : value);
  });
};

var durationToHoursAndMinutes = function durationToHoursAndMinutes(durationInMinutes) {
  var hours = Math.floor(durationInMinutes / 60);
  var minutes = durationInMinutes % 60;
  return {
    hours: hours,
    minutes: minutes
  };
};

var mock$t = function mock$t(value, options) {
  var _context;

  return _concatInstanceProperty(_context = "mock$t: ".concat(value, " with options ")).call(_context, _JSON$stringify(options));
};
var mock$tc = function mock$tc(value, options) {
  var _context2;

  return _concatInstanceProperty(_context2 = "mock$tc: ".concat(value, " with options ")).call(_context2, _JSON$stringify(options));
};
var stubValidationProvider = {
  template: "<div><slot v-bind='{ errors: [] }'/></div>"
};

var findRouteByName = function findRouteByName(routes, name) {
  return _findInstanceProperty(routes).call(routes, function (route) {
    return route.name === name;
  });
};

export { API_ORIGIN, API_VERSION_FEBRUARY_2021, API_VERSION_JULY_2021, BRING_API_KEY, BRING_USER_ID, I18N_BASE_URL, I18N_FALLBACK_LOCALE, I18N_SHEET_NAME, IS_SENTRY_ENABLED_LOCALLY, OrderClient, RELEASE_VERSION, addComment, apiOriginWithCountry, applyRequestInterceptorsInOrder, captureExceptionWithSentry, clearLocalStorageIfOnNewVersion, configureSentry, confirmRegistrationOrPasswordRecovery, defaRetailerGroupHandle, defaultMessageConfigurationFn, defaultTimeout, documentBaseUrl, durationToHoursAndMinutes, environment, extractCountryFromHostname, extractDomainFromEmail, extractDomainFromEmailIncludingAtSymbol, findRouteByName, formatDate, formatDateShort, formatDateShortWithDots, formatDatetime, formatDatetimeLong, formatDatetimeShort, formatDatetimeShortWithSeconds, fromUrlToApplication, fromUrlToApplicationDisplayName, getApiBaseUrl, getAutomaticallySwitchActiveRetailer, getCommentsForOrder, getCountry, getCurrencyForLocale, getFullNameRule, getLangInLocalStorage, getLocale, getOrderStatuses, getOrganizationNumberRule, getPasswordRule, getPersonalIdentificationNumberRule, getPlaceForPostalCode, getPostalCodeRule, getRequiredAllowNullRule, getRetailerGroupInLocalStorage, getTelephoneRule, getUserPreferenceValue, getVuexLocalStorageKey, homecheckOptions, imagesBaseUrl, inDenmark, inFinland, inNorway, inSweden, isAuthenticationError, isAuthorizationError, isElliOrder, isLanguageSwitcherEnabled, isNotFoundError, isRegistrationUsernameAlreadyTakenError, isSupportedLocale, isTimeout, mapCountryToLanguage, markCommentAsRead, mediaBaseUrl, mock$t, mock$tc, onLocal, onLocalOrTest, onProduction, onTest, parseDateShortWithDots, pdfBaseUrl, publicRetailerGroupHandle, requestInterceptorAddContextLegacy, requestInterceptorAddCustomHeaders, resendConfirmationEmail, responseInterceptorExtractData, retailerGroupLogoSrc, retailerGroupLogosUrl, serviceDetails, setAuthorizationHeaderOnConfig, setAutomaticallySwitchActiveRetailer, setLangInLocalStorage, setLangOnHtmlElement, setMainAndBackupTranslations, setRetailerGroupInLocalStorage, setUserForSentry, setUserPreferenceValue, setupThemingOnRootElement, shouldErrorBeReported, stubValidationProvider, supportedLocales, userFriendlyErrorMessage, validationConfigForFields, withAxiosRetry, withDefaultAxiosTransformers };
